import React from 'react';
import { Box, Icon } from '@material-ui/core';
import useStyles from 'app/cluster-styles/useStyles';

export default function QuotaWarningBanner({ quotas }) {
    const classes = useStyles();
    if (!quotas?.exceeded) return null;

    return (
        <Box p={2} my={2} bgcolor="#FFF3E0" borderRadius={1}>
            {quotas.usedCpus > quotas.cpus && (
                <span className={classes.error2}>
                    <Icon>error</Icon> <span>The quota of CPUs established by the provider is exceeded</span>
                </span>
            )}
            {quotas.usedNetwork > quotas.network && (
                <span className={classes.error2}>
                    <Icon>error</Icon> <span>The quota of network established by the provider is exceeded</span>
                </span>
            )}
            {quotas.usedInstances > quotas.instances && (
                <span className={classes.error2}>
                    <Icon>error</Icon> <span>The quota of instances established by the provider is exceeded</span>
                </span>
            )}
        </Box>
    );
}
